import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import StyledHtmlContent from '../common/StyledHtmlContent';

interface SectionItem {
  title?: string;
  description?: string;
}

const LotteryU888Section: React.FC = () => {
  const { t } = useTranslation();

  const section2Items = t('lottery.section2.content', { returnObjects: true }) as SectionItem[];
  const section3Items = t('lottery.section3.content', { returnObjects: true }) as (string | SectionItem)[];
  const section4Items = t('lottery.section4.content', { returnObjects: true }) as (string | SectionItem)[];
  const section5Items = t('lottery.section5.content_array', { returnObjects: true }) as (string | SectionItem)[];

  return (
    <>
      <Helmet>
        <title>{t('meta.lottery.title')}</title>
        <meta name="description" content={t('meta.lottery.description')} />
        <link rel="canonical" href="https://www.u888winbet.com/lottery" />
      </Helmet>
      <section className="bg-[#1a1a1a] text-xl text-white px-4 py-8 mt-[7rem] md:mt-[11rem]">

        <h1 className="text-center text-2xl md:text-3xl font-bold text-[#ff5c00]">
          {t('lottery.main_title')}
        </h1>

        {/* Intro */}
        <div className="mt-4 max-w-4xl mx-auto text-center leading-relaxed">
          <StyledHtmlContent html={t('lottery.intro')} />
        </div>

        {/* Image */}
        <div className="w-full max-w-5xl mx-auto mt-10 mb-10 px-4">
          <img
            src="/u888-banner.jpg"
            alt="U888 Promotion"
            className="rounded-md w-full h-auto"
          />
          <label className="block text-center italic mt-2 text-lg">
            {t('home.image_hint')}
          </label>
        </div>

        {/* Sections */}
        <div className="space-y-12">
          {/* Section 1 */}
          <div>
            <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mb-4">
              {t('lottery.section1.title')}
            </h2>
            <div className="max-w-4xl mx-auto text-center leading-relaxed">
              <StyledHtmlContent html={t('lottery.section1.content')} />
            </div>
          </div>

          {/* Section 2 */}
          <div>
            <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mb-4">
              {t('lottery.section2.title')}
            </h2>
            <div className="max-w-4xl mx-auto leading-relaxed">
              <StyledHtmlContent html={t('lottery.section2.content')} />
            </div>
            {/* <div className="max-w-4xl mx-auto space-y-4">
            {Array.isArray(section2Items) &&
              section2Items.map((item, idx) => (
                <div key={idx}>
                  <h3 className="font-semibold text-[#ffb347]">{item.title}</h3>
                  <p className="text-base md:text-lg">{item.description}</p>
                </div>
              ))}
          </div> */}
          </div>

          {/* Section 3 */}
          <div>
            <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mb-4">
              {t('lottery.section3.title')}
            </h2>
            <div className="max-w-4xl mx-auto leading-relaxed">
              <StyledHtmlContent html={t('lottery.section3.content')} />
            </div>
            {/* <ul className="list-disc list-inside max-w-4xl mx-auto space-y-2">
            {Array.isArray(section3Items) &&
              section3Items.map((item, idx) => (
                <li key={idx}>
                  {typeof item === 'string'
                    ? item
                    : `${item.title}: ${item.description}`}
                </li>
              ))}
          </ul> */}
          </div>

          {/* Section 4 */}
          <div>
            <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mb-4">
              {t('lottery.section4.title')}
            </h2>
            <div className="max-w-4xl mx-auto leading-relaxed">
              <StyledHtmlContent html={t('lottery.section4.content')} />
            </div>
            {/* <ul className="list-disc list-inside max-w-4xl mx-auto space-y-2">
            {Array.isArray(section4Items) &&
              section4Items.map((tip, idx) => (
                <li key={idx}>
                  {typeof tip === 'string'
                    ? tip
                    : `${tip.title ?? ''} ${tip.description ?? ''}`}
                </li>
              ))}
          </ul> */}
          </div>

          {/* Section 5 */}
          <div>
            <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mb-4">
              {t('lottery.section5.title')}
            </h2>
            <div className="max-w-4xl mx-auto leading-relaxed">
              <StyledHtmlContent html={t('lottery.section5.content')} />
            </div>
            <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mb-4">
              {t('lottery.section5.title_sub')}
            </h2>
            <ol className="list-decimal list-inside max-w-4xl mx-auto space-y-2">
              {Array.isArray(section5Items) &&
                section5Items.map((step, idx) => (
                  <li key={idx}>
                    {typeof step === 'string'
                      ? step
                      : `${step.title ?? ''} ${step.description ?? ''}`}
                  </li>
                ))}
            </ol>
          </div>
        </div>

        <p className="mt-12 max-w-4xl mx-auto leading-relaxed font-semibold">
          {t('lottery.section5.content_end')}
        </p>
      </section>
    </>
  );
};

export default LotteryU888Section; 